import React from 'react';
import InputWrapper from '../wrapper/InputWrapper';
import { IMaskInputProps } from 'types/components/inputs/input.interface';
import { InputMask } from '@react-input/mask';

const MaskInput = ({
  replacement = { _: /./, A: /[A-Za-z]/, '#': /\d/ },
  ...props
}: IMaskInputProps) => {
  return (
    <InputWrapper
      {...props}
      render={inputProps => (
        <InputMask replacement={replacement} {...inputProps} />
      )}
    />
  );
};

export default MaskInput;
